import React, { useState, useEffect } from "react";
import BASE_URL from "../../config";

export default function Aboutus() {

  const [form, setForm] = useState({
    // name: "",
    // description: "",
    image: null
  });

  const [preview, setPreview] = useState("");

  // 🔥 Fetch existing data
  useEffect(() => {
   fetch(`${BASE_URL}/api/getAbout.php`)
      .then(res => res.json())
      .then(data => {
        if (data) {
          setForm({
            // name: data.name || "",
            // description: data.description || "",
            image: null
          });

          setPreview(
           `${BASE_URL}/uploads/${data.image}`
          );
        }
      });
  }, []);

  // input change
  // const handleChange = (e) => {
  //   setForm({ ...form, [e.target.name]: e.target.value });
  // };

  // file change
  const handleFile = (e) => {
    setForm({ ...form, image: e.target.files[0] });

    // preview image
    setPreview(URL.createObjectURL(e.target.files[0]));
  };

  // submit
  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    // formData.append("name", form.name);
    // formData.append("description", form.description);

    if (form.image) {
      formData.append("image", form.image);
    }

   fetch(`${BASE_URL}/api/addAbout.php`, {
      method: "POST",
      body: formData
    })
      .then(res => res.text())
      .then(data => {
        alert(data);
      });
  };

  return (
    <div className="form-container">
      <h2>અમારા વિશે</h2>

      <form onSubmit={handleSubmit} className="form">
{/* 
        <label>નામ</label>
        <input
          type="text"
          name="name"
          value={form.name}
          onChange={handleChange}
          required
        />

        <label>માહિતી</label>
        <textarea
          name="description"
          value={form.description}
          rows="15"
          onChange={handleChange}
          required
        /> */}

        <label>ફોટો</label>
        <input type="file" onChange={handleFile} />

        {/* 🔥 Preview */}
        {preview && (
          <img src={preview} width="640"  alt="preview" />
        )}

        <button type="submit">સાચવો</button>
      </form>
    </div>
  );
}